import SessionCard from './SessionCard';

export default SessionCard;
